import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const SearchIcon: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--search')}
    width="19px"
    height="19px"
    viewBox="0 0 19 19"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <g id="Action" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Action/-Search-(Normal)"
        transform="translate(-8.000000, -7.000000)"
        stroke="#000000"
        strokeWidth="1.5"
      >
        <g id="icon" transform="translate(8.000000, 7.000000)">
          <path
            d="M12.0096067,12.4163625 L17.1115176,17.5532981"
            id="Line-5"
            strokeLinecap="square"
          />
          <ellipse
            id="Oval-7"
            cx="7.44886364"
            cy="7.5"
            rx="6.69886364"
            ry="6.75"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default SearchIcon;
